import React from 'react';
import { User, Settings as SettingsIcon, LogOut } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useAmazonConnection } from '../hooks/useAmazonConnection';

export const Header: React.FC = () => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const { isConnected, isLoading: isConnectionLoading } = useAmazonConnection();

  const handleSignOut = async () => {
    try {
      await signOut();
      // Redirect to landing page after successful sign out
      navigate('/', { replace: true });
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <header className="bg-gray-800 border-b border-gray-700 px-6 py-4 flex items-center justify-end h-16 fixed top-0 left-0 right-0 z-30 shadow-lg lg:pl-20">
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-3">
          <div className="text-right hidden sm:block">
            <p className="text-sm font-medium text-white">{user?.email || 'User'}</p>
            <div className="flex items-center justify-end gap-2">
              {!isConnectionLoading && (
                <Link
                  to="/settings?tab=amazon"
                  className={`text-sm ${
                    isConnected
                      ? 'text-gray-300 hover:text-white'
                      : 'text-amber-400 hover:text-amber-300'
                  }`}
                >
                  {isConnected ? 'Connected' : 'Not connected'}
                </Link>
              )}
            </div>
          </div>
          <div className="relative group">
            <button className="w-8 h-8 bg-cashy-purple-500 rounded-full flex items-center justify-center">
              <User size={16} className="text-white" />
            </button>
            <div className="absolute right-0 top-full mt-2 w-48 bg-gray-800 rounded-lg shadow-lg border border-gray-700 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
              <div className="p-2">
                <div className="px-3 py-2 border-b border-gray-700 mb-1">
                  <p className="text-sm font-medium text-white">{user?.email}</p>
                  <p className="text-xs text-gray-300">Signed in</p>
                </div>
                <button 
                  onClick={() => navigate('/settings')}
                  className="w-full text-left px-3 py-2 text-sm hover:bg-gray-700 rounded flex items-center gap-2 text-gray-200"
                >
                  <SettingsIcon size={14} />
                  Settings
                </button>
                <button 
                  onClick={handleSignOut}
                  className="w-full text-left px-3 py-2 text-sm hover:bg-gray-700 rounded flex items-center gap-2 text-red-400 hover:text-red-300"
                >
                  <LogOut size={14} />
                  Sign Out
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
